module.exports = __webpack_public_path__ + "img/tracker.17a0d496.svg";